import React, {useState} from 'react'
import MapListItem from './Item'
import Pagination from './Pagination'

const MapList = (props: any) => {
    const items = props.mapData.pins.filter(x => x.map === true)
    const totalEntries: number = items.length
    const perPage: number = 10
    const [currentIndex, setCurrentIndex] = useState<number>(0)
    const [page, setPage] = useState(0)

    const currentListPage = items.slice((currentIndex * perPage), ((currentIndex * perPage) + perPage))

    const totalPages = Math.ceil(totalEntries / perPage)
    if (totalEntries === 0) {
      return (
        <>
          <h2>There are no available locations that match your
                selection.</h2>
        </>
      )
    }

    return (
      <>
        <ul className="sopa--poi-list">
          {currentListPage.map((item, idx: number) => (
            <MapListItem activeDetail={props.activeDetail}
              setMapActive={props.setMapActive}
              setActiveDetail={props.setActiveDetail}
              id={item.id}
              setCurrentIndex={setCurrentIndex}
              activePins={props.activePins}
              currentPageIdx={currentIndex}
              setDetailsPanelActive={props.setDetailsPanelActive}
              key={idx} category={item.category.id}
              venue={item.venue !== null ? item.venue.name : ''}
              title={item.title}
              description={item.description}
              setListTarget={props.setListTarget}
              icon={item.icon}/>
          ))}
        </ul>
        {totalEntries > perPage &&
          <Pagination setPage={setPage} setCurrentIndex={setCurrentIndex}
            pages={totalPages} startIdx={0}
            currentPageIdx={currentIndex}/>}
      </>
    )
}

export default MapList
